
import { defineComponent } from "vue";
import Divider from "primevue/divider";

export default defineComponent({
  components: {
    Divider,
  },
});
